﻿import { Kb3dModel } from '../decorators/kb3d-decorator';
import { instanceOf } from '../decorators/model-utils';
import { eCylinderCap } from '../enums';
import { ICylinderNode } from '../kb3d-models';
import { Kb3dObject } from '../kb3d-object';
import { Token } from '../token';
import { PrimitiveMeshNode } from './primitive-mesh-node';

@Kb3dModel({
    token: Token.CylinderNode,
})
export class CylinderNode extends PrimitiveMeshNode implements ICylinderNode {
    public constructor() {
        super();
    }
    public height: number;
    public radius: number;
    public arc: number;

    public tessellation: number;
    public subdivisions: number;
    public capMode: eCylinderCap;
}

export function isCylinderMesh(node: Kb3dObject): node is CylinderNode {
    return instanceOf(node, Token.CylinderNode);
}
